/* global VXConfig */
import Flux from '../../flux/Flux';
import { Component, createRef } from 'react';

import PropTypes from 'prop-types';
import ReloadHelper from '../../utils/ReloadHelper';
import Tooltip from '../Tooltip/Tooltip.js';

class ActorStatus extends Component {
	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);

		this.tooltipRef = createRef();
	}

	onClick(e) {
		if (this.props.link) {
			if (VXConfig.isVXMobilePlatform) {
				ReloadHelper.reloadWithReactRouter(this.props.link, e, Flux.Messenger.isRestorePreviousUrl());
			} else {
				ReloadHelper.reloadWithPjax(this.props.link, e);
				if (typeof this.props.onClose === 'function') {
					this.props.onClose();
				}
			}
		} else if (typeof this.props.onClose === 'function') {
			this.props.onClose();
		}
	}

	render() {
		// get CSS class
		let actorStatusClassName = 'actor-status';
		if (this.props.size) {
			actorStatusClassName += ' -size-' + this.props.size;
		}
		if (typeof this.props.isActorOnline === 'undefined') {
			actorStatusClassName += ' is-undefined';
		} else if (this.props.isActorOnline) {
			actorStatusClassName += ' is-online';
		} else if (this.props.isActorMobileVideoCall) {
			actorStatusClassName += ' is-videocall';
		} else {
			actorStatusClassName += ' is-offline';
		}

		// set style for preview picture
		const actorStatusStyle = this.props.previewPictureUrl
			? {
					backgroundImage: 'url(' + this.props.previewPictureUrl + ')',
					backgroundPosition: 'center center',
					backgroundSize: 'cover',
				}
			: {};

		// create element
		let actorStatus = (
			<>
				<span className={actorStatusClassName} style={actorStatusStyle} ref={this.tooltipRef} />
				<Tooltip targetRef={this.tooltipRef} content={this.props.tooltip ? this.props.tooltip : ''} />
			</>
		);
		// add link

		if (this.props.link !== false && this.props.link !== '') {
			actorStatus = (
				<a href={this.props.link} className="h-cursor-pointer" onClick={this.onClick}>
					{actorStatus}
				</a>
			);
		}

		return actorStatus;
	}
}

ActorStatus.propTypes = {
	isActorOnline: PropTypes.bool.isRequired,
	isActorMobileVideoCall: PropTypes.bool,
	previewPictureUrl: PropTypes.string.isRequired,
	size: PropTypes.string,
	link: PropTypes.string,
	tooltip: PropTypes.string,
	onClose: PropTypes.func,
};
ActorStatus.defaultProps = {
	isActorMobileVideoCall: false,
	size: '',
	link: '',
	tooltip: '',
};

export default ActorStatus;
